import { apiFetch } from '../fetch';
import { PageOptions } from './interfaces';

export const getPageOptions = (): Promise<PageOptions> => apiFetch('/PageOptions/Enums');
